import { TFunction } from '@lyearn/i18n';
import { OptionInput } from '@/types/schema';

const validatePictureChoiceQuestion = (t: TFunction, options: OptionInput[]) => {
  const optionsWithoutPictures = options.filter((option) => !option.attachments?.length);
  if (!optionsWithoutPictures.length) {
    return;
  }

  const isCorrectOptionMissingPicture =
    optionsWithoutPictures.length === 1 && optionsWithoutPictures[0].optionEvaluation;

  const message = isCorrectOptionMissingPicture
    ? t('QuizCreator:Validations.CorrectOptionMissingPicture')
    : t('QuizCreator:Validations.OptionMissingPicture', { count: optionsWithoutPictures.length });

  return { message, type: 'OptionMissingPicture' };
};

export default validatePictureChoiceQuestion;
